<template>
  <form @submit.prevent="submit">
    <Field
      label="url"
      @input="$v.resource.mailchimp_url.$touch()"
      @handleChange="handleChange"
      v-model="resource.mailchimp_url"
      placeholder="//USERNAME.us14.list-manage.com/subscribe/post-json"
      :error="mailchimp_urlError"
    />

    <Field
      label="user id"
      @input="$v.resource.mailchimp_user_id.$touch()"
      @handleChange="handleChange"
      v-model="resource.mailchimp_user_id"
      placeholder="391827xh87661bahs4h8714h2"
      :error="mailchimp_user_idError"
    />

    <Field
      label="list id"
      @input="$v.resource.mailchimp_list_id.$touch()"
      @handleChange="handleChange"
      v-model="resource.mailchimp_list_id"
      placeholder="52d2d55a6z"
      :error="mailchimp_list_idError"
    />

    <Field
      label="popup"
      type="checkbox"
      @input="$v.resource.popup.$touch()"
      @handleChange="handleChange"
      v-model="resource.popup"
      :error="popupError"
      :value="true"
    />

    <Field
      label="heading"
      @input="$v.resource.heading.$touch()"
      @handleChange="handleChange"
      v-model="resource.heading"
      :error="headingError"
    />

    <div class="btn-save">
      <Btn :class="{'changes-made': changesMade}">Save Changes</Btn>
    </div>
  </form>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'

import {errorMessages} from '@/lib/error_messages'
import {required} from 'vuelidate/lib/validators'

export default {
  name: 'MailchimpForm',

  mixins: [form],

  components: {
    Btn
  },

  computed: {
    ...errorMessages([
      'mailchimp_url',
      'mailchimp_user_id',
      'mailchimp_list_id',
      'popup',
      'heading'
    ])
  },

  validations: {
    resource: {
      mailchimp_url: {required},
      mailchimp_user_id: {required},
      mailchimp_list_id: {required},
      popup: {},
      heading: {required}
    }
  }
}
</script>
